export default "__VITE_ASSET__nZ3V5IZ3__"